import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('supplier_bank_account'),
    subtitle: defineMessage('define_which_validation_iers_bank_account_field'),
    optionFilled: defineMessage('must_be_filled'),
    optionEmpty: defineMessage('can_be_empty'),
};
